/**
 * @file An image preloading component.
 */

import { Component } from 'react';
import PropTypes from 'prop-types';

class ImagePreload extends Component {
  static propTypes = {
    urls: PropTypes.arrayOf(PropTypes.string),
  };

  componentDidMount() {
    this.preloadImages();
  }

  componentDidUpdate() {
    this.preloadImages();
  }

  preloadImages = () => {
    const { urls } = this.props;

    if (!urls || !urls.length) {
      return;
    }

    urls.forEach(url => {
      const image = new Image();
      image.src = url;
    });
  };

  render() {
    return null;
  }
}

export default ImagePreload;
